import { useEffect, useState } from "react";
import { Redirect, Router } from "@reach/router";
import { connect, useDispatch } from "react-redux";
import { SearchForm } from "./SearchForm";
import { SearchContainer } from "./SearchContainer";
import {
	removeAllToListDirect,
	removeSupplierList,
	searchCompanies,
} from "../../actions/searchActions";
import { getAllDisciplines } from "../../actions/searchActions";
import { ContentContainer } from "components/Layout";
import { isProcurer, isProcurerNBidder } from "utils/helpers";
import { Box } from "@chakra-ui/react";
import { useCurrentCompany, useCurrentUser } from "hooks/auth";
const NotFound = () => {
	return <h1>ERROR: PATH NOT FOUND</h1>;
};

const SearchConnected = ({
	searchCompanies,
	compareList,
	shortlist,
	projectId,
	getAllDisciplines,
	lockedCompareItems,
	lockedSearchItems,
}) => {
	const [allowAccess, setAllowAccess] = useState("init");
	const [loading, setLoading] = useState("true");
	const [supplierlist, setSupplierList] = useState({});
	const dispatch = useDispatch();
	const currentCompany = useCurrentCompany();
	const { isSuperAdmin } = useCurrentUser();


	useEffect(() => {
		if (!currentCompany) {
			return;
		}
		if (
			isSuperAdmin ||
			isProcurer(currentCompany) ||
			isProcurerNBidder(currentCompany)
		) {
			setAllowAccess("allow");
			setTimeout(() => {
				setLoading(false);
			}, 100);
		} else {
			setAllowAccess("dissalow");
			setTimeout(() => {
				setLoading(false);
			}, 100);
		}
	}, [currentCompany, isSuperAdmin]);

	useEffect(() => {
		getAllDisciplines();
	}, [getAllDisciplines]);

	const getPathUrl = () => {
		let url = new URL(window.location.href);
		let params = new URLSearchParams(url.search);
		let supplier = params.get("supplier");
		let supplierlistName = params.get("supplierlist");
		let directcompare = false;
		if (params.get("directcompare") === "true") {
			directcompare = true;
		}
		let directshortlist = false;
		if (params.get("directshortlist") === "true") {
			directshortlist = true;
		}

		if (supplier) {
			let supplierlistTemp = {
				id: supplier,
				name: supplierlistName,
				directcompare: directcompare,
				directshortlist: directshortlist,
				suppliers:
					params
						.get("suppliers")
						?.split(",")
						?.map((id) => Number(id)) || [],
			};
			setSupplierList(supplierlistTemp);
			return supplierlistTemp;
		} else {
			return null;
		}
	};

	const doSearchCompanies = async (value, resume, page) => {
		let supplierlistTemp = getPathUrl();

		if (supplierlistTemp) {
			return await searchCompanies(value, resume, page, supplierlistTemp);
		} else {
			setSupplierList({});
			dispatch(removeAllToListDirect());
			dispatch(removeSupplierList());
			return await searchCompanies(value);
		}
	};

	useEffect(() => {
		getPathUrl();
	}, []);
	return (
		<>
			{loading === false && (
				<>
					{allowAccess === "allow" ? (
						<Box
							display="flex"
							flexWrap="nowrap"
							width="100%"
							minH="100vh"
						>
							{/* <ContextMenu
								name={company_current.name}
								logo={company_current.logo_path}
							/> */}
							<ContentContainer noPadding={true}>
								<Router
									primary={false}
									style={{ width: "100%" }}
								>
									<SearchForm
										path="/"
										projectId={projectId}
										searchCompanies={doSearchCompanies}
									/>
									<SearchContainer
										path="/:groupId/*"
										supplierlist={supplierlist}
										compareList={compareList}
										shortlist={shortlist}
										lockedCompareItems={lockedCompareItems}
										lockedSearchItems={lockedSearchItems}
									/>
									<NotFound default />
								</Router>
							</ContentContainer>
						</Box>
					) : (
						<Redirect to="/" />
					)}
				</>
			)}
			{loading === true && <>loading</>}
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		locations: [],
		projectId: state.search.projectId,
		compareList: state.search.compareList,
		shortlist: state.search.shortlist.map((shortlistItem) => {
			let companyInCompare = state.search.compareList.find(
				(compareItem) => compareItem.id === shortlistItem.id
			);
			return companyInCompare ? companyInCompare : shortlistItem;
		}),
		lockedSearchItems:
			state.search.searchResult &&
			state.search.lockedSearchItems.map((lockedCompanyId) =>
				state.search.searchResult.find(
					(company) => company.id === lockedCompanyId
				)
			),
		lockedCompareItems:
			state.search.searchResult &&
			state.search.lockedCompareItems.map((lockedCompanyId) =>
				state.search.compareList.find(
					(company) => company.id === lockedCompanyId
				)
			),
	};
};

export const Search = connect(mapStateToProps, {
	searchCompanies,
	getAllDisciplines,
})(SearchConnected);
